module.exports = __webpack_public_path__ + "static/media/Group 1000005683.05d432f3.svg";